import { html, css, LitElement } from 'lit';
import { NexusComponent } from "./nexus.component";

class TicketsNavigationComponent extends NexusComponent {
    static shadowRootOptions = { ...LitElement.shadowRootOptions, mode: 'open', delegatesFocus: true };
    static properties = {
        step: {
            type: Number,
            attribute: 'step',
            reflect: true,
        },
        maximumSteps: {
            type: Number,
            attribute: 'maximumsteps',
            reflect: true,
        },
        lastStep: {
            type: Number,
            attribute: 'laststep',
            reflect: true,
        }
    };
    previousStepClass = 'previous-step';
    nextStepClass = 'next-step';
    submitStepClass = 'submit-step';
    constructor() {
        super();
        this.step = 1; // assuming 1!
        this.maximumSteps;
        this.lastStep;
    }

    setEventListeners() {
        this.addEventListener('click', this.handleClick);
        if (typeof window !== 'undefined') {
			window.addEventListener('hashchange', (event) => {
				this.onHashChange(event);
			});

		}
    }

    static get styles() {
        // Write styles in standard CSS
        // https://stackoverflow.com/questions/25193964/how-can-i-have-a-web-components-width-and-height-be-inherited-by-its-children
        return css`
			:host {
                display: block;
                position: relative;
                margin: 0;
			}
		`;
    }

    handleSlotChange(event) {
        //const childNodes = event.target.assignedNodes({ flatten: true });
        let childNodes = event.target.querySelectorAll('.previous-step, .next-step');
        console.log('handleSlotChange', event, childNodes);
    }

    connectedCallback() {
        super.connectedCallback();
        this.previous = this.querySelector('.previous-step');
        this.next = this.querySelector('.next-step');
        this.handleNavigationButtons();
        this.setEventListeners();
    }

    handleNavigationButtons() {
        let submit = this.querySelector('.submit-step');
        if (this.previous) {
            if (this.step == 1) {
                this.previous.style.visibility = 'hidden';
                this.previous.style.height = 0;
                this.previous.style.marginTop = `-20px`;
            } else {
                this.previous.style.visibility = 'visible';
                this.previous.style.height = 'auto';
                this.previous.style.marginTop = 0;
                setTimeout(() => {
                    this.previous.href = `#step-${this.step - 1}`;
                }, 10);
            }
        }
        if (this.next) {
            if (this.step == this.maximumSteps) {
                this.next.style.visibility = 'hidden';
                this.next.style.height = 0;
                this.next.style.marginTop = `-20px`;
            } else {
                setTimeout(() => {
                    this.next.href = `#step-${this.step + 1}`;
                }, 10)
                this.next.style.visibility = 'visible';
                this.next.style.height = 'auto';
                this.next.style.marginTop = 0;
            }
        }
        if (submit) {
            if (this.step == this.maximumSteps) {
                submit.style.display = 'block';
            } else {
                submit.style.display = 'none';
            }
        }
        // console.log('handleNavigationButtons', previous, next, this.step);
    }

    attributeChangedCallback(name, _old, value) {
        super.attributeChangedCallback(name, _old, value);
        // console.log('attributeChangedCallback', name, _old, value);
        if (name === 'step') {
            this.handleNavigationButtons();

        }
        if (name === 'maximumsteps') {
            this.handleNavigationButtons();
        }
    }


    get _slottedChildren() {
        const slot = this.shadowRoot.querySelector('slot');
        if (slot) {
            return slot.assignedElements({ flatten: true });
        } else {
            return [];
        }
    }

    render() {
        return html`
            <div class="tickets-navigation" component-loaded>
                <slot @slotchange="${this.handleSlotChange}">...</slot>
            </div>
        `;
        // Step debug: ${this.step}
    }

    /**
     * Limit by max steps
     */
    limitMax() {
        console.log('limitMax');
        if (this.step < this.maximumSteps) {
            this.step += 1;
        }
    }

    /**
     * only allow step 1 or higher
     */
    limitMin() {
        console.log('limitMin');
        if (this.step > 1) {
            this.step -= 1;
        }
    }

    /**
     * 
     * @param {PointerEvent} event 
     */
    handleClick(event) {
        // event.preventDefault();
        // next
        this.handleNavigationButtons();
        if (event.target.classList.contains(this.nextStepClass)) {
            this.limitMax();
        }

        // previous
        if (event.target.classList.contains(this.previousStepClass)) {
            this.limitMin();
        }
        let steppables = this.querySelectorAll('stepper-container, tickets-steps-container');
        // console.log('steppables', steppables);
        steppables.forEach((child) => {
            child.setAttribute('step', this.step);
        });
        console.log('handleClick', event, event.target);
        if (event.target && event.target.type == 'submit') {
        }
    }

    onHashChange(event) {
        console.log('[TicketsNavigationComponent] onHashChange', event);
        this.handleLastStep();
    }

    handleLastStep() {
        console.log('[TicketsNavigationComponent] handleLastStep');
        if (this.step === this.maximumSteps) {
            this.lastStep = true;
        } else {
            this.lastStep = null;
        }
        if (this.lastStep === true) {
            this.triggerEventOnElement('nexus.analytics.event.begin_checkout', document);
        }
    }


    nextStep(event) {
        console.log('nextStep', event);
    }
    previousStep(event) {
        console.log('previousStep', event);
    }
}

window.customElements.define('tickets-navigation', TicketsNavigationComponent);